import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel
} from '@ionic/react'
import { createOutline } from 'ionicons/icons'
import React from 'react'

interface Props {
  onEdit?: () => any
  address: any
  condensed?: boolean
}

export const AddressCard: React.FC<Props> = (props) => {
  if (!props.address) {
    return null
  }

  if (props.condensed) {
    return (
      <IonCard>
        <IonCardHeader>
          <IonCardTitle>Adresse</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          {props.address.riskAddress && props.address.riskAddress.gstnr && (
            <div>
              Grundstücksnummer: {props.address.riskAddress.gstnr}
            </div>
          )}

          <div>
            {props.address.street} {props.address.house}{props.address.stairs && `/${props.address.stairs}`}{props.address.door && `/${props.address.door}`}
          </div>
          <div>
            {props.address.zipCode} {props.address.city}
          </div>
        </IonCardContent>
      </IonCard>
    )
  }

  return (
    <IonCard>
      <IonCardHeader>
        {props.onEdit && (
          <IonButton
            style={{
              position: 'absolute',
              zIndex: 10,
              right: 10,
              top: 10,
            }}
            onClick={props.onEdit}
            fill={'clear'}
          >
            <IonIcon slot="icon-only" icon={createOutline} />
          </IonButton>
        )}
        <IonCardTitle>Adresse</IonCardTitle>
      </IonCardHeader>

      {props.address.riskAddress && props.address.riskAddress.gstnr && (
        <IonItem>
          <IonLabel position="floating">Grundstücksnummer</IonLabel>
          <IonInput value={props.address.riskAddress.gstnr} readonly/>
        </IonItem>
      )}

      <IonItem>
        <IonLabel position="floating">Straße</IonLabel>
        <IonInput value={props.address.street} readonly />
      </IonItem>

      {props.address.house && (
        <IonItem>
          <IonLabel position="floating">Hausnummer</IonLabel>
          <IonInput value={props.address.house} readonly/>
        </IonItem>
      )}

      {props.address.stairs && (
        <IonItem>
          <IonLabel position="floating">Stiege</IonLabel>
          <IonInput value={props.address.stairs} readonly/>
        </IonItem>
      )}

      {props.address.door && (
        <IonItem>
          <IonLabel position="floating">Türe</IonLabel>
          <IonInput value={props.address.door} readonly/>
        </IonItem>
      )}

      <IonItem>
        <IonLabel position="floating">PLZ</IonLabel>
        <IonInput value={props.address.zipCode} readonly />
      </IonItem>

      <IonItem>
        <IonLabel position="floating">Ort</IonLabel>
        <IonInput value={props.address.city} readonly />
      </IonItem>
    </IonCard>
  )
}
